import { FormattedMessage } from "react-intl";

import Nbsp from "@components/Nbsp";
import ExternalLink from "@components/typography/ExternalLink";
import { ResourceFragment } from "@typing/Generated";

type Props = {
  hotline: NonNullable<ResourceFragment["hotline"]>;
};

const HotlineLink = ({ hotline }: Props) => (
  <ExternalLink href={`tel:${hotline.phoneNumber}`}>
    {hotline.phoneNumber}
    <Nbsp />
    <FormattedMessage id="dictionary.punctuation.dash" />
    <Nbsp />
    {hotline.name}
  </ExternalLink>
);

export default HotlineLink;
